import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"

const { Title, Paragraph } = WebsiteTypography

const SuccessAoiApproval: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { setIsModalDarkOpen } = useModalDarkContext()

  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <>
      <Row className={"delivery-sent-notice-wrapper"} justify={"center"} style={{ marginTop: 24 }}>
        <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
          <Row justify={"center"} style={{ paddingBottom: 24 }}>
            <SvgIcon type={"circled-tick"} color={"green"} />
          </Row>

          <Title level={xxl || xl || lg || md || sm ? 3 : 5} centered className={"form-section-title"}>
            <span>{"AOI Approved"}</span>
            <span className={"bold"}>{" Successfully"}</span>
          </Title>

          <DividerWithHex marginBottom={16} marginTop={32} />

          <Paragraph
            centered
            style={{ paddingTop: 24 }}
            color={"white"}
            size={xxl || xl || lg || md || sm ? "md" : "sm"}
          >
            {
              "The Area of Interest application has been approved successfully. All related records and approval details have been updated accordingly."
            }
          </Paragraph>

          <Row justify={"center"} style={{ paddingTop: 40 }}>
            <Col xxl={8} xl={8} lg={8} md={10} sm={14} xs={16}>
              <Button btnType={"primary"} onClick={handleClose} text={"Close"} size={"large"} block />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default SuccessAoiApproval
